export class Credentials {
    email: string;
    password: string;
    auto: boolean;
    rememberLoginChecked: boolean;

    constructor(obj: Object) {
        Object.assign(this, obj);
    }
}
